import React from "react";
import { formatDateTime } from "../utils";

const DataBlock = ({ title, data }) => {
  return (
    <div className="logs-data-block">
      <h4>{title}</h4>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
};

const LogDetailsPanel = ({ log }) => {
  if (!log) {
    return (
      <section className="logs-details empty">
        <h3>Select an event</h3>
        <p>Choose a log from the left side to inspect complete details.</p>
      </section>
    );
  }

  return (
    <section className="logs-details">
      <header className="logs-details-header">
        <h3>{log.title}</h3>
        <span>{formatDateTime(log.eventTime)}</span>
      </header>

      <div className="logs-meta-grid">
        <div>
          <small>Service</small>
          <p>{log.serviceName || "-"}</p>
        </div>
        <div>
          <small>Actor</small>
          <p>{log.actorLabel}</p>
        </div>
        <div>
          <small>Route</small>
          <p>{log.routeName || "-"}</p>
        </div>
        <div>
          <small>Event</small>
          <p>{log.eventName || "-"}</p>
        </div>
      </div>

      <div className="logs-data-grid">
        <DataBlock title="Incoming Data" data={log.normalizedIncomingData} />
        <DataBlock title="Data Before Change" data={log.normalizedBeforeData} />
        <DataBlock title="Data After Change" data={log.normalizedAfterData} />
      </div>
    </section>
  );
};

export default LogDetailsPanel;
